// @ts-expect-error errore nel modulo da fixare
import { QuestionabilePlugin } from "@open-terzo-settore/questionabile-ng";
import "@open-terzo-settore/questionabile-ng/dist/style.css";

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(QuestionabilePlugin, {
    modules: ["pro"],
    apiKey: "fk-5c046e28fb",
    config: {
      //rootClasses
    },
  });
});
